export default function SiteFooter() {
    return (
        <footer
            data-testid="site-footer"
            className="relative bg-slate-900 text-slate-300 pt-16 pb-28 md:pb-16"
        >
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-8">
                    <div>
                        <p className="text-xs font-semibold tracking-[0.2em] uppercase text-[#FACC15] mb-3">
                            AIS Festival
                        </p>
                        <h3 className="font-display font-black tracking-tighter text-4xl sm:text-5xl text-white leading-none">
                            See you <br /> on the 18th.
                        </h3>
                    </div>
                    <div className="text-sm space-y-2 md:text-right">

                        <p className="text-slate-500 pt-2">
                            © {new Date().getFullYear()} AIS. All rights
                            reserved.
                        </p>
                    </div>
                </div>
            </div>
        </footer>
    );
}
